<template>
  <el-card>
    <div
      slot="header"
      class="clearfix"
    >
      <span>Túranaptár szabályok</span>
      <el-button
        style="float: right; margin-top: -5px;"
        type="success"
        size="small"
        @click="$router.replace('/representative-processes/tour-calendar-rules/add')"
        icon="el-icon-plus"
        v-can="'tourcalendarrules.create'"
      >
        Új szabály
      </el-button>
    </div>
<!--    <div v-loading="loading" style="min-height: 81px;">-->
<!--      <table-filter-->
<!--        v-if="filterConfig"-->
<!--        :config="filterConfig"-->
<!--        action="tourCalendar/fetchAll"-->
<!--      />-->
<!--    </div>-->
    <el-alert
      title="Túraterv generálás"
      type="info"
      :closable="false"
      description="A túraszabályok alapján minden vasárnap 17:00-kor generálódik ki a következő heti túraterv."
      show-icon
      style="margin-bottom: 20px;"
    />
    <tour-calendar-list :items="items" />
    <template v-if="$route.meta.showAddTourCalendarRuleDialog">
      <tour-calendar-dialog
        type="add"
        @update="update"
      />
    </template>
    <template v-if="$route.meta.showUpdateTourCalendarRuleDialog">
      <tour-calendar-dialog
        :tour-calendar-id="$route.params.id"
        type="update"
        @update="update"
      />
    </template>
  </el-card>
</template>

<script>
  import tourCalendarList from '../../components/representativeProcesses/tourCalendarRules/List';
  import tourCalendarDialog from '../../components/representativeProcesses/tourCalendarRules/Dialog';
  import TableFilter from '../../components/TableFilter';

  export default {
    components: {
      tourCalendarList,
      tourCalendarDialog,
      TableFilter,
    },
    data() {
      return {
        items: [],
        loading: false,
        filterConfig: null,
      };
    },
    async mounted() {
      this.loading = true;
      await this.setConfig();
      await this.fetch();
      this.loading = false;
    },
    methods: {
      async fetch() {
        this.loading = true;
        this.items = await axios.get('api/tour-calendar-rules');
        this.loading = false;
      },

      update() {
        this.fetch()
      },

      async setConfig() {
        let users = this.$store.getters['user/users'];
        if(!users.length) {
          await this.$store.dispatch('user/fetchAll');
          users = this.$store.getters['user/users'];
        }
        this.filterConfig = [
          {
            type: 'select',
            name: 'user',
            options: users,
            label: 'Képviselő',
            labelCallback: user => user && `${user.last_name} ${user.first_name} (@${user.username})` || '',
            valueKey: 'id',
            defaultSearch: true,
          },
          {
            type: 'multipleRemoteSelect',
            name: 'shop_id',
            label: 'Üzlet',
            labelCallback: shop => shop && `#${shop.id} ${shop.name}` || '',
            valueKey: 'id',
            remoteSearchParam: 'name',
            remoteAction: 'shop/search',
          },
          {
            type: 'dateRange',
            name: 'start_date',
            label: 'Kezdés időpontja',
          }, {
            type: 'dateRange',
            name: 'start_date',
            label: 'Kezdés időpontja',
          },
        ];
      },
    },
  };
</script>
